import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, LineChart, Zap, TreePine, Building2, Users } from 'lucide-react';

const areas = [
  {
    icon: Leaf,
    title: 'Sustainable Finance',
    description: 'Investigating innovative financial mechanisms for sustainable development projects.'
  },
  {
    icon: LineChart,
    title: 'Climate Economics',
    description: 'Analyzing economic impacts and opportunities in climate change adaptation.'
  },
  {
    icon: Zap,
    title: 'Energy Finance',
    description: 'Researching financing solutions for renewable energy transitions.'
  },
  {
    icon: TreePine,
    title: 'Natural Capital',
    description: 'Studying financial mechanisms for biodiversity and ecosystem services.'
  },
  {
    icon: Building2,
    title: 'Urban Resilience',
    description: 'Exploring financing for climate-resilient urban infrastructure.'
  },
  {
    icon: Users,
    title: 'Social Impact',
    description: 'Assessing socio-economic implications of climate finance initiatives.'
  }
];

export default function ResearchAreas() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl font-bold text-gray-900">Research Focus Areas</h2>
          <p className="mt-4 text-xl text-gray-600">
            Our research spans key areas in climate finance and sustainability
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {areas.map((area, index) => {
            const Icon = area.icon;
            return (
              <motion.div
                key={area.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow"
              >
                <div className="flex items-center space-x-4 mb-6">
                  <div className="bg-green-100 p-3 rounded-full">
                    <Icon className="h-6 w-6 text-green-600" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">
                    {area.title}
                  </h3>
                </div>
                <p className="text-gray-600">{area.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}